import styled from "styled-components";
import draft from "../../asserts/img/draft.svg";
import waitting from "../../asserts/img/fi-rs-bell-ring.svg";
import inProgress from "../../asserts/img/in_progress.svg";
import finished from "../../asserts/img/check-circle.svg";
import { useMobile } from "../../utils/mobile";
import { useTranslation } from "react-i18next";

const getImgByStatus = (row) => {
  if (row.INITSTATFLAG === "Y") {
    return draft;
  }
  if (row.ACTIVEFLAG === "Y") {
    return inProgress;
  }
  if (row.FINAL === "Y") {
    return finished;
  }
  if (row.ADCFREEZEFLAG === "Y") {
    return waitting;
  }

  return undefined;
};

const StyledDiv = styled.div(({ theme, color, isRtl }) => ({
  backgroundColor: color ? color : theme.color.text,
  display: "flex",
  flexDirection: "row",
  padding: isRtl ? `4px 5px 4px 10px` : `4px 10px 4px 5px`,
  alignItems: "center",
  borderRadius: 14,
  width: "auto",
  overflow: "hidden",
  whiteSpace: "wrap",
  textOverflow: "ellipsis",
  textAlign: "start",
  height: 29,
}));

const Value = styled.label(({ theme, color }) => ({
  fontSize: 14,
  color: color === `rgb(255,255,255)` ? theme.color.label : theme.color.white,
  textAlign: "start",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "auto",
}));

const Img = styled.img(() => ({}));

const Status = ({ status, color, row }) => {
  const isMobile = useMobile();
  const { i18n } = useTranslation();

  const isRtl = i18n.dir() === "rtl";

  return (
    <StyledDiv color={color} isMobile={isMobile} isRtl={isRtl}>
      <Img src={getImgByStatus(row)} style={{ marginInlineEnd: 5 }} />
      <Value color={color}>{status} </Value>
    </StyledDiv>
  );
};

export default Status;
//export { getColorByStatus };
